<template>
  <transition name="bbe-fade">
  <VuePerfectScrollbar class="bbe-contacts-list"
                       v-click-outside="setForceHide"
                       v-if="visibility">
    <div class="bbe-contacts-list-item"
         :class="{'bbe-contacts-list-item__active': activeContactIndex === index}"
         @click="setContact(contact, true)"
         v-for="(contact, index) in findElements"
         :key="contact.name + index">
      <div class="bbe-contacts-list-item__photo"></div>
      <div class="bbe-contacts-list-item-info">
        <div class="bbe-contacts-list-item-info__name">{{contact.name}}</div>
        <div class="bbe-contacts-list-item-info__mail">{{contact.email}}</div>
      </div>
    </div>
  </VuePerfectScrollbar>
  </transition>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {trim, words, includes, uniqBy, last} from 'lodash'

export default {
  name: 'ContactsList',
  props: ['model', 'disabled', 'modelName', 'selectMode', 'list', 'addressees'],
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      checkedContact: false,
      activeContactIndex: false,
      forceHide: false
    }
  },
  computed: {
    contactsList: {
      get () {
        return this.$store.getters.contactsListMail
      },
      set (data) {
        this.$store.dispatch('setContactListMail', data)
      }
    },
    findElements () {
      if (this.selectMode) return this.list
      const contacts = uniqBy(this.contactsList, 'email')
      const model = trim(this.model).toLowerCase()
      const recipients = words(model, /[^, |\s]+/g)
      const search = last(recipients)
      const result = []
      contacts.forEach(item => {
        let includesInName = false
        const names = words(item.name)
        names.forEach(name => {
          includesInName = includes(name.toLowerCase(), search) || includesInName
        })
        const mail = item.email.toLowerCase()
        const hasInMail = includes(mail, search) && search !== mail
        if (hasInMail || includesInName) {
          result.push(item)
        }
      })
      return result
    },
    visibility () {
      const findEls = this.model.length > 1 && this.findElements.length > 0 && !this.checkedContact && !this.disabled
      return (this.selectMode || findEls) && !this.forceHide
    },
    activeContact () {
      return this.forceHide ? {} : this.findElements[this.activeContactIndex] || {}
    }
  },
  methods: {
    keyDown (e) {
      const arrowDown = e.keyCode === 40
      const arrowUp = e.keyCode === 38
      const enter = e.keyCode === 13
      const esc = e.keyCode === 27
      if (arrowDown) {
        this.setContactDown()
      } else if (arrowUp) {
        this.setContactUp()
      } else if (enter) {
        this.setContact(this.activeContact)
      } else if (esc) {
        this.setForceHide()
      }
    },
    setContactDown () {
      const isLast = this.activeContactIndex < this.findElements.length - 1
      this.activeContactIndex === false ? this.activeContactIndex = 0 : this.activeContactIndex += +isLast
    },
    setContactUp () {
      const isFirst = this.activeContactIndex === 0
      this.activeContactIndex === false ? this.activeContactIndex = 0 : this.activeContactIndex -= +!isFirst
    },
    setForceHide () {
      this.forceHide = true
    },
    setContact (contact, isClick) {
      if (!contact || !contact.email) return
      if (this.selectMode) {
        this.$emit('setContact', contact, this.modelName)
        return
      }
      this.checkedContact = contact.email
      const recipients = words(this.model, /[^, |\s]+/g)
      recipients.splice(-1, 1, contact.email)
      this.$emit('setContact', recipients.join(', '), isClick)
    }
  },
  watch: {
    model () {
      this.forceHide = false
      this.checkedContact = this.model === this.checkedContact && this.checkedContact
    }
  },
  beforeMount () {
    document.addEventListener('keyup', this.keyDown, false)
  },
  beforeDestroy () {
    document.removeEventListener('keyup', this.keyDown, false)
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbe-contacts-list {
    @include global-font;
    position: absolute;
    left: 0;
    top: calc(100% + 4px);
    max-width: 270px;
    min-width: 200px;
    max-height: 170px;
    background-color: $color-white;
    box-shadow: 0 0 13px rgba($color-accent, 0.18);
    border-radius: 6px;
    padding: 15px 0;
    z-index: 10;
    overflow: hidden;

    &-item {
      display: flex;
      align-items: center;
      padding: 10px 12px;
      cursor: pointer;
      transition: .2s;

      &:hover, &__active {
        background-color: $color-gallery;
      }

      &__photo {
        display: none;
      }

      &-info {
        &__name {
          font-size: 12px;
          color: $color-black;
          margin-bottom: 5px;
        }

        &__mail {
          font-size: 11px;
          color: $color-silver-chalice;
        }
      }
    }
  }

</style>

<style lang="scss">
  @import "../../../sass/variables";

  .bbe-contacts-list {
    .ps__rail-y.ps--clicking .ps__thumb-y, .ps__rail-y:focus > .ps__thumb-y,
    .ps__rail-y:hover > .ps__thumb-y,
    .ps .ps__rail-y .ps__thumb-y, .ps__thumb-y {
      width: 3px;
      background-color: $color-wild-sand;
      z-index: 3;
      right: 2px;
    }

    .ps__rail-y,
    .ps__rail-x.ps--clicking,
    .ps__rail-x:focus,
    .ps__rail-x:hover,
    .ps__rail-y.ps--clicking,
    .ps__rail-y:focus,
    .ps__rail-y:hover{
      background-color: transparent;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/FormsElements/ContactsList.vue